export default __webpack_public_path__ + "static/media/iyc_news.6e2ccaa1.svg";